<template>
  <div class="py-sm px-twenty flex items-center justify-between font-normal gap-sm rounded-full bg-offWhite border-none">
    <BasePopover
      trigger="hover"
      :disabled="!textIsTruncated"
      :delay="300"
    >
      <template v-slot:reference>
        <div
          class="pr-0 m-0 whitespace-nowrap text-signableBrandColours-black text-14 max-w-DismissibleInfoPill truncate select-none"
          data-test="text"
          ref="textRef"
        >
          {{ text }}
        </div>
      </template>
      <template v-slot:popper-content>
        <span>{{ text }}</span>
      </template>
    </BasePopover>
    <button
      @click="$emit('dismiss', id, text)"
      class="bg-offWhite border-none flex items-center cursor-pointer p-0 text-dark3 hover:text-signableBrandColours-black active:text-dark3"
      data-test="dismiss-button"
      :aria-label="$t('library.pills.dismissiblePill.removeItemFromList', {item: text})"
    >
      <XMarkIcon aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';
import { XMarkIcon } from '@/components/library/icons';
import BasePopover from '@/components/library/popovers/BasePopover.vue';

export default defineComponent({
  components: { XMarkIcon, BasePopover },
  props: {
    text: String,
    id: String,
    ec: String,
  },
  setup(props) {
    const textRef = ref(null);

    const textIsTruncated = computed(() => {
      if (props.text && textRef.value) {
        return textRef.value.offsetWidth < textRef.value.scrollWidth;
      }
      return false;
    });

    return {
      textRef,
      textIsTruncated,
    };
  },
});

</script>

